import api from '../../api.js';

export const SIDEMENU_CLASS = api.core.ns('sidemenu');
export const SIDEMENU_LIST_CLASS = api.core.ns('sidemenu__list');
